import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../components/Modal/Modal";
import Button from "../../components/Button/Button";
import styles from "./CancelSubscriptionModal.module.css";

const CancelSubscriptionModal = ({
  isOpen,
  onCloseButtonClick,
  onConfirmCancel,
}) => {
  return (
    <div className="container">
      <Modal
        isOpen={isOpen}
        className="modal"
        header="Cancel Subscription"
        footer={
          <div className={styles.footerButtons}>
            <Button
              className={`${styles.noButton}`}
              label="NO"
              onClick={onCloseButtonClick}
            />{" "}
            <Button
              label="YES"
              onClick={onConfirmCancel}
              className={styles.confirmButton}
              color="red"
            />
          </div>
        }
        children={
          <div>
            <p>
              Are you sure you want to cancel your subscription? Your
              subscription will remain active until the next renewal period, and
              you will not be charged after that.
            </p>
          </div>
        }
      />
    </div>
  );
};

CancelSubscriptionModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  onConfirmCancel: PropTypes.func,
};

export default CancelSubscriptionModal;
